<template>
  <v-footer
      v-if="currentDoc && !inRotationMode"
      :height="footer_height" style="background-color:white"
      inset
      app
      class="pa-0 footer"
    >

    <v-dialog v-if="showPaymentAccountDialog" v-model="showPaymentAccountDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline title-color">Asiento de Pago Manual</v-card-title>
        <v-card-text class="mt-4">
          <doc-text-field
            kind="account"
            v-model="manualAccount"
            :rules="accountRules"
            label="Cuenta de Pago / Cobro (Manual)" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" outlined text class="primary-border" @click="noCreatePaymentLine()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="createPaymentLine()" >Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MessagePopup v-if="show_message" :message="message" :show_message="show_message" @close-message="closeMessage"></MessagePopup>

      <v-toolbar clipped>
        <v-btn icon color="primary" :disabled="!account_move" 
        @click="click_footer()">
          <v-icon v-if="!min_footer">mdi-arrow-down</v-icon>
          <v-icon v-else>mdi-arrow-up</v-icon></v-btn>
        <!-- Establecemos los TABS -->
        <v-tabs v-model="tab" grow>
          <v-tab @click="set_active_tab('account_move')" v-if="currentDoc.forced_move" >Asiento (Editado)</v-tab>
          <v-tab @click="set_active_tab('account_move')" v-else >Asiento </v-tab>
          <v-tab @click="set_active_tab('paid_move')" 
            :disabled="(paid_account_move_lines && paid_account_move_lines.length == 0) && !currentDoc.forced_move"
            v-if="feature_payment_move"
          >Asiento de Pago</v-tab>
        </v-tabs>
        <v-spacer/>
        <template cols="1" align="left" 
              v-if="['error_creating_moves', 'error_validating_moves', 'pending_review', 'error_account_connector'].includes(currentDoc.state)">
                <v-btn outlined class="mr-2" v-if="currentDoc.forced_move" color="primary" @click="reverse_amounts_in_lines()">
                  <v-icon v-once>mdi-autorenew</v-icon>
                </v-btn>
                <v-btn outlined class="mr-2" v-if="currentDoc.forced_move" color="primary" @click="change_sign_amounts_in_lines()">
                  Cambiar Signo
                </v-btn>
        </template>
        <template 
        v-if="account_move">
          <v-btn v-if="!['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)" color="primary" outlined class="mr-2"  :disabled="!currentDoc.forced_move" 
            v-on="{ click: (active_tab === 'paid_move') ? addPaidLine : addLine }"
            ><v-icon v-once>
                  mdi-plus
          </v-icon></v-btn>
          <v-btn v-if="showPaymentAccountDialogButton" class="mr-2"
            :loading="loading_doc_account_moves" color="primary" @click="openShowPaymentAccountDialog()"
            :disabled="currentDoc.state=='pending_connect' || dirty || isWaitingFlow"
          >
            Asiento de Pago Manual
          </v-btn>
          <v-btn v-if="!currentDoc.forced_move && !['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)" :loading="loading_doc_account_moves" color="primary" @click="enableDisableAccountMoveInputs();show_lines()"
            :disabled="currentDoc.state=='pending_connect' || dirty || isWaitingFlow"
          >
            Editar asiento
          </v-btn>
          <v-btn v-if="currentDoc.forced_move && !['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)" outlined color="primary" :loading="loading_doc_account_moves" @click="cancelEdit()"
          :disabled="currentDoc.state=='pending_connect'">
            Cancelar edición
          </v-btn>
        </template>
          <v-btn v-else outlined color="primary" @click="clickForceMove()"
          :disabled="dirty || isWaitingFlow || currentDoc.state=='pending_connect' || !isValidDate(currentDoc.metadata['invoice_date']) || (currentDoc.companydb_gestion_cartera && !isValidDate(currentDoc.metadata['due_date']))">
            Asiento Manual
          </v-btn>
      </v-toolbar>
      <v-card
        v-if="account_move"
        flat
        width="100%"
        height="270"
        class="text-center ma-6"
        style="overflow-y:scroll"
      >
        


              <!-- Y, ahora, el contenido -->
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row no-gutters class="sm2">
              <v-col cols="4" sm="2" md="1">
                <v-toolbar-title v-if="account_move" cols="2" class="primary--text pa-1">Número:</v-toolbar-title>
              </v-col>
              <v-col cols="8" sm="5" md="3">
                <v-text-field 
                  v-if="account_move"
                  regular
                  color="primary" 
                  label=""
                  v-model="account_move.mov_number" 
                  dense
                  hide-details
                  readonly
                  class="ml-2 pl-1"
                  cols="2"
                ></v-text-field>
              </v-col>
              <div v-if="balance" class="error--text pt-2 pl-4">{{'Descuadre: '+balance }}</div>
            </v-row>

          <v-row>&nbsp;</v-row>
            

            <v-row class="table-head-row" no-gutters>
              <v-col cols="1" class="primary--text table-right-head"/>
              <v-col cols="2" class="primary--text table-head">Cuenta</v-col>
              <v-col cols="4" class="primary--text table-head">Descripción</v-col>
              <v-col cols="2" class="primary--text table-head">Debe</v-col>
              <v-col cols="2" class="primary--text table-head">Haber</v-col>
              <v-col cols="1" class="primary--text table-left-head">T.Imp.</v-col>
            </v-row>

            <v-row  class="table-row" no-gutters v-for="(account_move_line, index) in account_move_lines" v-bind:key="index" align="center" justify="center">
              <v-col cols="1" class="table-right-head">
                <v-btn icon color="primary" :disabled="!currentDoc.forced_move || forcePayMoveEdit" @click="deleteLine(index)" ><v-icon v-once>
                  mdi-delete
                </v-icon></v-btn>
              </v-col>
              <v-col cols="2" class="table-head">
                <DocTextField
                      label=""
                      :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                      :required="true"
                      v-model="account_move_line.account"
                      :class="{invalid:currentDoc && !account_move_line.account}"
                      :disabled="(!currentDoc.forced_move && !edit_only_accounts) || forcePayMoveEdit"
                      :items="got_feature('feature_accounts_master') ? accounts : []"
                       @get-values="getValues"
                       @reset-items="resetItems"
                ></DocTextField>
              </v-col>
              <v-col cols="4" class="table-head">
                <DocTextField 
                  label="" 
                  v-model="account_move_line.description" 
                  :required="true"
                  hide-details
                  :disabled="!currentDoc.forced_move || forcePayMoveEdit"
                ></DocTextField>
              </v-col>
              <v-col cols="2" class="table-head" v-if="account_move_line.line_type == 'apunte'">
                <DocTextField
                  label="" 
                  kind="number"
                  :required="true"
                  v-model="account_move_line.debit" 
                  :disabled="!currentDoc.forced_move || forcePayMoveEdit"
                ></DocTextField>
              </v-col>
              <v-col cols="2" class="table-head" v-if="account_move_line.line_type == 'apunte'">
                <DocTextField
                  label="" 
                  kind="number"
                  :required="true"
                  v-model="account_move_line.credit" 
                  :disabled="!currentDoc.forced_move || forcePayMoveEdit"
                ></DocTextField>
                
              </v-col>
              <v-col cols="1" class="table-left-head">
                <DocTextField 
                  v-if="currentCompany" 
                  label="" 
                  v-model="account_move_line.type_iva"
                  hide-details
                  :required="requiredTypeIvaLine(account_move_line)"
                  :disabled="!currentDoc.forced_move || forcePayMoveEdit"
                ></DocTextField>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="1" class="primary--text"></v-col>
              <v-col cols="4" class="primary--text"></v-col>
              <v-col cols="2" class="primary--text total-left-cell pt-1 pr-2 text-center">Total</v-col>
              <v-col cols="2" class="primary--text total-center-cell pt-1 pr-2 text-right">{{totalDebit}}</v-col>
              <v-col cols="2" class="primary--text total-right-cell pt-1 pr-2 text-right">{{totalCredit}}</v-col>
              <v-col cols="1" class="table-aux "></v-col>
            </v-row>

          </v-tab-item>
        
          <v-tab-item v-if="!paid_account_move_lines || paid_account_move_lines.length == 0">
              <v-row>&nbsp;</v-row>
              <v-alert prominent text type="success">No se han creado Asientos del tipo indicado</v-alert>
          </v-tab-item>

          <!-- Asiento de pago -->
          <v-tab-item v-if="paid_account_move_lines && paid_account_move_lines.length > 0">

            <v-row no-gutters>
              <v-col cols="1">
                <v-toolbar-title v-if="paid_account_move" class="primary--text pa-1">Número:</v-toolbar-title>
              </v-col>
              <v-col cols="3">
                <v-text-field 
                  v-if="paid_account_move"
                  regular
                  color="primary" 
                  label="" 
                  v-model="paid_account_move.mov_number" 
                  dense
                  hide-details
                  readonly
                  class="ml-2"
                ></v-text-field>
              </v-col>

              <div v-if="balancePaid" class="error--text pt-2 pl-4">{{'Descuadre: '+ balancePaid }}</div>
            </v-row>

            <v-row>&nbsp;</v-row>

            <v-row class="table-head-row" no-gutters>
              <v-col cols="1" class="primary--text table-right-head"/>
              <v-col cols="2" class="primary--text table-head">Cuenta</v-col>
              <v-col cols="4" class="primary--text table-head">Descripción</v-col>
              <v-col cols="2" class="primary--text table-head">Debe</v-col>
              <v-col cols="2" class="primary--text table-head">Haber</v-col>
              <v-col cols="1" class="primary--text table-left-head">T.Imp.</v-col>
            </v-row>
            
            <!-- Pintamos, aquí los movimientos relacionados -->
            <v-row   class="table-row" no-gutters v-for="(paid_move, index) in paid_account_move_lines" v-bind:key="index" align="center" justify="center">
              <v-col cols="1" class="table-right-head">
                  <v-btn icon color="primary" :disabled="!currentDoc.forced_move" @click="deletePaidLine(index)" ><v-icon v-once>
                    mdi-delete
                  </v-icon></v-btn>
              </v-col>
              <v-col cols="2" class="table-head">
                  <DocTextField
                    label="" 
                    :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                    :required="true"
                    v-model="paid_move.account"
                    :class="{invalid:currentDoc && !paid_move.account}"
                    :disabled="!currentDoc.forced_move"
                    :items="got_feature('feature_accounts_master') ? accounts : []"
                    @get-values="getValues"
                    @reset-items="resetItems"
                  ></DocTextField>
                </v-col>
                <v-col cols="4" class="table-head">
                  <DocTextField 
                    label="" 
                    v-model="paid_move.description" 
                    :required="true"
                    hide-details
                    :disabled="!currentDoc.forced_move"
                  ></DocTextField>
                </v-col>
                <v-col cols="2" class="table-head" v-if="paid_move.line_type == 'apunte'">
                  <DocTextField
                    label="" 
                    kind="number"
                    :required="true"
                    v-model="paid_move.debit" 
                    :disabled="!currentDoc.forced_move"
                  ></DocTextField>
                </v-col>
                <v-col cols="2" class="table-head" v-if="paid_move.line_type == 'apunte'">
                  <DocTextField
                    label="" 
                    kind="number"
                    :required="true"
                    v-model="paid_move.credit" 
                    :disabled="!currentDoc.forced_move"
                  ></DocTextField>
                  
                </v-col>
                <v-col cols="1" class="table-left-head">
                  <DocTextField 
                    v-if="currentCompany" 
                    label="" 
                    v-model="paid_move.type_iva"
                    hide-details
                    :required="requiredTypeIvaLine(paid_move)"
                    :disabled="!currentDoc.forced_move"
                  ></DocTextField>
                </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="1" class="primary--text"></v-col>
              <v-col cols="4" class="primary--text"></v-col>
              <v-col cols="2" class="primary--text total-left-cell pt-1 pr-2 text-center">Total</v-col>
              <v-col cols="2" class="primary--text total-center-cell pt-1 pr-2 text-right">{{ totalDebitPaid }}</v-col>
              <v-col cols="2" class="primary--text total-right-cell pr-2 text-right">{{ totalCreditPaid }}</v-col>
              <v-col cols="1" class="table-aux "></v-col>
            </v-row>

          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-footer>
</template>

<script>
import DocTextField from "./DocTextField.vue"
import MessagePopup from "./MessagePopup.vue";
import { mapGetters,mapActions, mapState, mapMutations} from "vuex"
import { createHelpers ,mapFields} from 'vuex-map-fields'
import {round, isValidDate} from '../utils'
import { vuexPrefix } from "../store/vuex_utils";
import { validateAccount } from "../utils/account_validation"
import {evaluate} from 'mathjs'
import { canEditAccountMove, canEditAccountsOnly } from "../modules/invoices/domain/Invoice"
import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"



const { mapMultiRowFields } = createHelpers({
  getterType: 'documents/getAccountMoveField',
  mutationType: 'documents/updateAccountMoveField',
});

    export default {
        name:'AccountMove',
        data(){
          return {
            loading_doc_account_moves: false,
            tab: 0,
            active_tab: 'account_move',
            showPaymentAccountDialog: false,
            manualAccount: 0,
            message: '',
            show_message: false,
            edit_only_accounts: false
          }
        },
        components:{
          DocTextField,
          MessagePopup,
        },
        computed:{
          ...mapGetters({
            currentDoc: 'documents/currentDocument',
            inRotationMode: 'documents/inRotationMode',
            dirty: 'documents/dirty',
            isWaitingFlow: "documents/isWaitingFlow",
            got_feature:'got_feature',
            userData: 'me/userData',
            min_footer: 'documents/min_footer',
            footer_height: 'documents/footer_height'
          }),
          ...mapState([
            'currentCompany'
          ]),
          account_move(){
            return (this.currentDoc && this.currentDoc.accountMoves.length)?this.currentDoc.accountMoves[0]:undefined
          },
          ...mapMultiRowFields(['account_move_lines', 'paid_account_move_lines']),
          ...mapFields('me',vuexPrefix('',['feature_payment_move'],'userData.available_features.')),
          ...mapFields('cru', ['accounts']),
          totalDebit(){
            try{
              if(this.account_move){
                return round(this.account_move_lines.map(x=>x.debit).reduce((x,y)=>this.num(x)+this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
          },
          totalCredit(){
            try{
              if(this.account_move){
                return round(this.account_move_lines.map(x=>x.credit).reduce((x,y)=>this.num(x)+this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
          },
          balance(){
            return round(this.totalDebit-this.totalCredit)
          },
          balancePaid(){
            return round(this.totalDebitPaid-this.totalCreditPaid)
          },
          paid_account_move(){
            return (this.currentDoc && this.currentDoc.accountMoves.length
              && this.currentDoc.accountMoves[0].paid_account_move && this.currentDoc.accountMoves[0].paid_account_move.length
            )
              ? this.currentDoc.accountMoves[0].paid_account_move[0] : undefined
          },
          paid_account_move_lines(){
            try
              {
                return (this.currentDoc && this.currentDoc.accountMoves.length
                  && this.currentDoc.accountMoves[0].paid_account_move
                  && this.currentDoc.accountMoves[0].paid_account_move.length > 0
                  && this.currentDoc.accountMoves[0].paid_account_move[0].account_move_lines
                  ) ? this.currentDoc.accountMoves[0].paid_account_move[0].account_move_lines : []
              } catch(err){
                console.error(err)
              }
            return undefined
          },
          totalCreditPaid(){
            try
            {
              if(this.paid_account_move_lines) {
                return round(this.paid_account_move_lines.map(x => x.credit).reduce((x,y) => this.num(x) + this.num(y),0))
              }
            } catch(err) {
              console.error(err)
            }
            return 0
          },
          totalDebitPaid(){
            try{
              if(this.paid_account_move_lines){
                return round(this.paid_account_move_lines.map(x => x.debit).reduce((x,y)=> this.num(x) + this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
          },
          accountRules() {
            return [
              (v) => !v ||  validateAccount(v) || 'La cuenta debe contener únicamente dígitos'
            ]
          },
          showPaymentAccountDialogButton() {
            return !this.currentDoc.forced_move
              && (
                this.currentDoc.kind == 'in_invoice'
                  && this.currentDoc.supplierdb_info && (
                    this.currentDoc.supplierdb_info.automatic_payment_account=='m' 
                    || (this.currentDoc.supplierdb_info.automatic_payment_account=='na' && this.currentCompany && this.currentCompany.automatic_payment_account=='m'))
                ||
                this.currentDoc.kind == 'out_invoice'
                  && this.currentDoc.customerdb_info &&  (
                    this.currentDoc.customerdb_info.automatic_charge_account=='m' 
                  || (this.currentDoc.customerdb_info.automatic_charge_account=='na' && this.currentCompany && this.currentCompany.automatic_charge_account=='m'))
              )
              && (!this.paid_account_move_lines || this.paid_account_move_lines.length == 0)
          },
          forcePayMoveEdit() {
            if(this.currentDoc.prorate && this.got_feature('feature_editar_asiento_pago')) {
              return true
            }
            return false
          }
        },
        created() {
          this.accounts = [];
        },
        methods:{
          num(x){
            if (x==='') {
              return 0;
            }else{
              return evaluate(x);
            }

          },
          ...mapMutations({
            addLine:'documents/addLine', 
            addPaidLine: 'documents/addPaidLine',
            deleteLine:'documents/deleteLine',
            deletePaidLine: 'documents/deletePaidLine',
            forceMove: "documents/forceMove",
          }),
          ...mapActions({
            setForcedMove: "documents/setForcedMove",
            fetchDocumentMetadata: "documents/fetchDocumentMetadata",
            continueFlow: "documents/continueFlow",
            cancelEditFlow: "documents/cancelEditFlow",
            saveAccountMoves: "documents/saveAccountMoves",
            createManualPaymentMoves: "documents/createManualPaymentMoves",
            showAccountMoveFooter: "documents/showAccountMoveFooter",
            hideAccountMoveFooter: "documents/hideAccountMoveFooter",
            initAccountMoveFooter: "documents/initAccountMoveFooter"
          }),
          ...mapActions("cru", ['getAccounts']),
          showMessage(m){
            this.message=m;
            this.show_message=true;
          },
          closeMessage(){
            this.show_message=false;
          },
          click_footer(){
            if(!this.min_footer){
              this.hide_lines()
            }
            else{
              this.show_lines()
            }
          },
          change_sign_amounts_in_lines(){
            this.currentDoc.accountMoves.forEach((account_move) => {
              account_move.account_move_lines.forEach((line) => {
                line.credit = line.credit*(-1)
                line.debit = line.debit*(-1)
              })
            })
          },
          reverse_amounts_in_lines(){
            this.currentDoc.accountMoves.forEach((account_move) => {
              account_move.account_move_lines.forEach((line) => {
                let aux = line.credit
                line.credit = line.debit
                line.debit = aux
              })
            })
          },
          enableAccountMoveInputs() {
            this.loading_doc_account_moves = true;
            this.setForcedMove(!this.currentDoc.forced_move);
            this.fetchDocumentMetadata({ id: this.currentDoc.id }).then(() => {
              if(!this.account_move){
                this.hide_lines()
              }
              this.loading_doc_account_moves = false;
            });
          },
          enableDisableAccountMoveInputs() {
            this.edit_only_accounts = false;
            let feature_repo = new VueFeatureRepository(this.got_feature)
            let message = canEditAccountMove(this.currentDoc,this.userData,feature_repo) // if can edit returns '' and  error message if not
            
            if (message && this.currentDoc.static_invoice) {
              let accountsOnlyMessage = canEditAccountsOnly(this.currentDoc, this.userData, feature_repo);
              if (!accountsOnlyMessage) {
                this.edit_only_accounts = true;
                this.loading_doc_account_moves = true;
                this.setForcedMove(true);
                this.fetchDocumentMetadata({ id: this.currentDoc.id }).then(() => {
                  if(!this.account_move){
                    this.hide_lines()
                  }
                  this.loading_doc_account_moves = false;
                });
                return;
              }
            }
            
            if (message){
              this.showMessage(message);
              if(this.forcePayMoveEdit) {
                this.enableAccountMoveInputs();
              }
            } else {
              this.enableAccountMoveInputs();
            }
          },
          start_check_async_job_state(id){
            this.check_async_job_state(id)
          },
          check_async_job_state(id){
            if(id==this.$store.state.documents.document.id.toString()){
                this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id }).then(() => {
                if(['pending','running'].includes(this.$store.state.documents.document.async_job_state)){
                  setTimeout(()=>this.check_async_job_state(this.$store.state.documents.document.id),3000)
                }
                else{
                  if(!this.account_move){
                    this.hide_lines()
                  }
                  else{
                    this.show_lines()
                  }
                }
              })
            }
            
          },
          clickForceMove() {
            let feature_repo = new VueFeatureRepository(this.got_feature)
            let message = canEditAccountMove(this.currentDoc,this.userData,feature_repo) // if can edit returns '' and  error message if not
            if (message){
              this.showMessage(message);
            } else {
              this.loading_doc_account_moves = true;
              this.setForcedMove(true);
              this.forceMove()
              this.saveAccountMoves()
              this.loading_doc_account_moves = false;
              this.show_lines()
            }
          },
          cancelEdit() {
            this.loading_doc_account_moves = true;
            this.setForcedMove(false);
            this.hide_lines()
            this.cancelEditFlow().then(() => {
              if(!this.account_move){
                this.hide_lines()
              }
              else{
                this.show_lines()
              }
              if(['pending','running'].includes(this.currentDoc.async_job_state)){
                setTimeout(()=>this.start_check_async_job_state(this.currentDoc.id),3000)
              }
              this.loading_doc_account_moves = false;
            });
            
          },
          hide_lines(){
            this.hideAccountMoveFooter();
          },
          show_lines(){
            this.showAccountMoveFooter();
          },
          isValidDate(d_str){
            return isValidDate(d_str)
          },
          set_active_tab(tab_value){
            this.active_tab = tab_value
          },
          openShowPaymentAccountDialog() {
            this.showPaymentAccountDialog = true
          },
          noCreatePaymentLine() {            
            this.showPaymentAccountDialog = false
          },
          createPaymentLine() {
            try {
              this.createManualPaymentMoves({
                "document_id" : this.currentDoc.id,
                "account" : this.manualAccount
              }).then(() => {}
                 //setTimeout(() => this.check_async_job_state(this.$store.state.documents.document.id), 2000)
                 )

              this.showPaymentAccountDialog = false
            } catch(err) {
              console.error(err)
            }            
          },
          getValues(params) {
            this.getAccounts(params).then(() => {});
          },
          resetItems(params) {
            this.accounts = params;
          },
          requiredTypeIvaLine(line) {
            return this.currentDoc && line && line.account && (line.account.startsWith('472') || line.account.startsWith('477')) && !line.type_iva && !((this.currentDoc.iva_parcial || this.currentDoc.gasto_iva_parcial) && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params.hasOwnProperty('allow_account_exc_expens_lines_no_IVA') && line.account.startsWith(this.currentCompany.companydb_type.params['allow_account_exc_expens_lines_no_IVA']));
          }
        },
        mounted(){
          this.initAccountMoveFooter(this.account_move);
        }
    }
</script>

<style scoped>
  .table-head >>> div > .v-text-field {
    margin-top: 0px;
  }
  .table-left-head >>> div > .v-text-field {
    margin-top: 0px;
  }
  .table-head >>> div > .v-text-field > .v-input__control > .v-input__slot {
    height: 36px;
  }
  .table-left-head >>> div > .v-text-field > .v-input__control > .v-input__slot {
    height: 36px;
  }
</style>

<style lang="scss" scoped>
    .primary-bckground {
        background-color: var(--v-primary-base);
    }
    .primary-border {
        border-color: var(--v-primary-base) !important;
    }
    .table-head {
        border-left-style:solid;
        border-right-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-right-head {
        border-right-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-left-head {
        border-left-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .total-center-cell {
      border-bottom-style: solid;
      border-right-style: solid;
      border-left-style: solid;
      border-color: var(--v-primary-base);
      border-width: thin;
    }
    .total-right-cell {
      border-bottom-style: solid;
      border-right-style: solid;
      border-left-style: solid;
      border-color: var(--v-primary-base);
      border-width: thin;

    }
    .total-left-cell {
      border-bottom-style: solid;
      border-left-style: solid;
      border-right-style: solid;
      border-color: var(--v-primary-base);
      border-width: thin;
    }
    .table-head-row {
      border-right-style: solid;
        border-left-style: solid;
        border-bottom-style: solid;
        border-top-style: solid;
        border-color: var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-right-style: solid;
        border-left-style: solid;
        border-bottom-style: solid;
        border-color: var(--v-primary-base);
        border-width: thin;
    }
    .table-aux{
      border-color:var(--v-primary-base);
      border-width: thin;
    }
    .footer {
      z-index: 101;
      max-height: 75%;
    }
</style>
